export const ROUTER_UTILS = {
  config: {
    base: {
      home: '',
    },
    auth: {
      root: 'auth',
      login: 'login',
      forgotPassword: 'forgot-password',
      forgotPasswordEmailSent: 'forgot-password-email-sent',
      passwordReset: 'password-reset',
      passwordResetFailed: 'password-reset-failed',
      passwordResetSucceeded: 'password-reset-succeeded',
    },
    settings: {
      root: 'settings',
      cateTpls: 'cate_tpls_mgmt',
      dataImport: 'data_import_mgmt',
      incentive: 'icis_mgmt',
      subsc: 'subsc_mgmt',
      users: 'users_mgmt',
      roles: 'roles_mgmt',
      account: 'account',
      notifications: 'notifications',
      security: 'security',
      securityLog: 'security-log',
      snapshot: 'snapshot',
      download: 'download_mgmt',
      techMgmt: 'tech_mgmt',
    },
    user: {
      root: 'user',
      overview: 'overview',
      profile: 'profile',
    },
    errorResponse: {
      notFound: '404',
    },
  },
  business: {
    dashboard: 'dashboard',
    ecommerce: 'ecommerce',
    bi:'bi',
    smb:'smb',
    incentive: {
      root: 'incentive',
      shareMyecom: 'share_myecom',
    },
    pdfViewer: 'pdfViewer',
    splitData: 'splitData'
  },
};
